import "src/decidim/accountability/index"

// Images
require.context("../images", true)
